import React from 'react';
import { Button, Form, FormGroup, InputGroup } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import ReduxTextField from "../common/ReduxTextField";

const ActivityFeedForm = props => {
    const { handleSubmit } = props;

    return (
        <Form onSubmit={handleSubmit}>
            <FormGroup bsSize="small">
               <InputGroup>
                    <Field
                        component={ReduxTextField}
                        name="body"
                        type="text"
                        placeholder="Post a message!"
                        fullWidth
                    />
                    <InputGroup.Button>
                        <Button disabled={!props.isAuthenticated} bsSize="small" type="submit">Submit</Button>
                    </InputGroup.Button>
                </InputGroup>
            </FormGroup>
        </Form>
    )
};

export default reduxForm({ form: 'feed' })(ActivityFeedForm);



// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeedForm.js